import React, { useMemo } from 'react';
import LayoutContext, { useLayout } from '../context';
import { FiftyFifty as StyledFiftyFifty } from '../../styled/containers.js';

const FiftyFifty = (props) => {
  const layout = useLayout();
  const memoisedValues = useMemo(
    () => ({ ...layout, insideHalfWidth: true }),
    [layout]
  );
  return (
    <LayoutContext.Provider value={memoisedValues}>
      <StyledFiftyFifty {...props} />
    </LayoutContext.Provider>
  );
};

export default FiftyFifty;
